import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n.use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		fallbackLng: 'en',
		supportedLngs: ['en', 'tr', 'fr', 'de', 'es', 'pt', 'ru', 'ar'],
		nonExplicitSupportedLngs: true,
		debug: true,
		keySeparator: false,
		interpolation: {
			escapeValue: false,
		},
		load: 'languageOnly',
		react: { useSuspense: true },
	});

window.__i18n = i18n;

export default i18n;
